<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <div class="px-0">

        <v-card-title class="headline pl-4 py-2 pr-2">
          Edytuj rozliczenie
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <div v-if="!dialogBusy">
          <div
            ref="scrollContainer"
            class="scrollable-height">
            <v-alert
              class="ma-0"
              v-model="error"
              dismissible
              type="error"
            >
              {{errorMsg}}
            </v-alert>

            <div class="pt-2">
              <div class="px-4">
                <v-text-field
                  v-model="formData.invoice_number"
                  label="Numer faktury"
                  :error-messages="errors.collect('invoice_number')"
                  v-validate="'max:30|min:3'"
                  data-vv-name="invoice_number"
                  data-vv-as="numer faktury"
                ></v-text-field>
              </div>


              <div class="px-4 pt-2">
                <div class="body-2 grey--text">Okres rozliczenia:</div>
              </div>


              <v-layout class="px-4 pb-2" wrap>
                <v-flex xs12 sm4 :class="pickerMargin">
                  <v-menu
                    ref="fromDateVisibility"
                    v-model="fromDateVisibility"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    :close-on-content-click="false"
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="parsedDateFrom"
                      label="Od"
                      readonly
                      append-outer-icon="event"
                      :error-messages="errors.collect('date_from')"
                      v-validate="'required'"
                      data-vv-name="date_from"
                      data-vv-as="okres rozliczenia"
                      required
                    ></v-text-field>
                    <v-date-picker
                      color="primary"
                      locale="pl-pl"
                      v-model="formData.date_from"
                      @input="$refs.fromDateVisibility.save(formData.date_from)"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-menu
                    ref="toDateVisibility"
                    v-model="toDateVisibility"
                    :nudge-right="40"
                    lazy
                    readonly
                    transition="scale-transition"
                    offset-y
                    full-width
                    :close-on-content-click="false"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="parsedDateTo"
                      label="Do"
                      readonly
                      append-outer-icon="event"
                      :error-messages="errors.collect('date_to')"
                      v-validate="'required'"
                      data-vv-name="date_to"
                      data-vv-as="okres rozliczenia"
                      required
                    ></v-text-field>
                    <v-date-picker
                      color="primary"
                      locale="pl-pl"
                      v-model="formData.date_to"
                      no-title
                      @input="$refs.toDateVisibility.save(formData.date_to)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>

              <v-divider></v-divider>

              <div class="px-4 pt-4">
                <div class="body-2 grey--text">Dostępne zasoby:</div>
              </div>

              <v-layout class="px-4" v-if="range" wrap>
                <v-flex xs4 sm2>
                  <v-text-field
                    v-model="formData.space_available"
                    :error-messages="errors.collect('space_available')"
                    v-validate="`required|min:${range.min}|max:${range.max}`"
                    data-vv-name="space_available"
                    data-vv-as="dostętpne zasoby"
                    type="number"
                    suffix="GB"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout class="grey--text body-2">
                    <v-flex xs2>
                      {{range.min}}GB
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs2 text-xs-right>
                      {{range.max}}GB
                    </v-flex>
                  </v-layout>
                  <v-slider
                    v-model="formData.space_available"
                    :max="range.max"
                    :min="range.min"
                  ></v-slider>
                </v-flex>
              </v-layout>

              <v-divider></v-divider>
              <v-layout class="px-4" align-center>
                <v-flex xs4>
                  <div class="body-2 grey--text">Zapłacone:</div>
                </v-flex>
                <v-flex xs8>
                  <v-switch
                    color="primary"
                    v-model="isPaid"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="px-4 py-4">
            <ServerErrors :errorsItems="serverErrors" />
            <v-spacer></v-spacer>
            <v-btn
              color="primary lighten-2"
              flat="flat"
              @click="setVisbility"
            >
              Anuluj
            </v-btn>

            <v-btn
              color="primary"
              :loading="busy"
              :disabled="busy"
              @click="updateSubscription"
            >
              Zapisz
            </v-btn>
          </v-card-actions>
        </div>
        <div v-if="dialogBusy">
          <div class="py-4 text-xs-center">
            <v-progress-circular
              :size="30"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getError, parseDate } from '../../../helpers/helpers';
import { getEditFormData } from '../../../repository/subscriptions';
import ServerErrors from '../../common/Errors/ServerErrors.vue';

export default {
  name: 'subscription-edit-dialog',
  components: {
    ServerErrors,
  },
  data: () => ({
    busy: false,
    fromDateVisibility: false,
    toDateVisibility: false,
    range: null,
    errorMsg: null,
    error: null,
    serverErrors: [],
    dialogBusy: false,
    formData: {
      invoice_number: null,
      date_from: null,
      date_to: null,
      space_available: 10,
      is_paid: true,
    },
  }),
  computed: {
    ...mapGetters('subscriptions', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'edit';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
    pickerMargin() {
      return this.$vuetify.breakpoint.xsOnly ? ' mr-0' : ' mr-4';
    },
    subscriptionId() {
      return this.dialogVisibility.id;
    },
    clientId() {
      return this.$route.params.id;
    },
    parsedDateFrom() {
      const fromDate = this.formData.date_from;
      return fromDate ? parseDate(this.formData.date_from) : null;
    },
    parsedDateTo() {
      const toDate = this.formData.date_to;
      return toDate ? parseDate(this.formData.date_to) : null;
    },
    isPaid: {
      get() {
        return this.formData.is_paid;
      },
      set(val) {
        this.formData.is_paid = val;
      },
    },
  },
  methods: {
    ...mapActions('subscriptions', [
      'setDialogVisbility',
      'subscriptionUpdate',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    getFormData() {
      this.getEditSubscriptionData();
    },
    clearData() {
      this.$validator.reset();
      this.busy = false;
      this.fromDateVisibility = false;
      this.toDateVisibility = false;
      this.range = null;
      this.dialogBusy = false;
      this.formData = {
        invoice_number: null,
        date_from: null,
        date_to: null,
        space_available: 10,
        is_paid: true,
      };
      this.clearErrors();
    },
    clearErrors() {
      this.errorMsg = null;
      this.error = null;
      this.serverErrors = [];
    },
    getServerErrors(errors) {
      const filedKeys = Object.keys(errors);
      filedKeys.forEach((fieldKey) => {
        const fieldErros = errors[fieldKey];
        if (!fieldErros[0] || fieldErros.length <= 0) return;
        fieldErros.forEach((err) => {
          const field = this.$validator.fields.find({
            name: fieldKey,
            scope: this.$options.scope,
          });
          if (field) {
            this.$validator.errors.add({
              id: field.id,
              field: fieldKey,
              msg: err,
              scope: this.$options.scope,
            });
            field.setFlags({
              invalid: true,
              valid: false,
              validated: true,
            });
          } else if (!this.serverErrors.includes(err)) {
            this.serverErrors.push(err);
          }
        });
      });
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
      this.$refs.scrollContainer.scrollTo(0, 0);
      if (errorData.response.data && errorData.response.data.data) {
        this.getServerErrors(errorData.response.data.data);
      }
    },
    async getEditSubscriptionData() {
      this.dialogBusy = true;
      try {
        const formRes = await getEditFormData(this.subscriptionId);
        const formData = formRes.data.data;
        this.range = formData.space_available_range;
        const subscriptionData = formData.subscription;
        this.formData = {
          ...this.formData,
          ...subscriptionData,
        };
        this.dialogBusy = false;
      } catch (e) {
        this.getError(e);
      }
    },
    updateSubscription() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.update();
        }
      });
    },
    async update() {
      this.busy = true;
      const data = {
        data: this.formData,
        id: this.subscriptionId,
        clientId: this.clientId,
      };
      try {
        await this.subscriptionUpdate(data);
        this.busy = false;
        this.setDialogVisbility(false);
        this.clearErrors();
      } catch (e) {
        this.getError(e);
      }
    },
  },
  watch: {
    visibility(val, oldVal) {
      if (val === true) {
        this.getFormData();
        this.errorMsg = null;
        this.error = null;
      }
      if (oldVal) {
        this.clearData();
      }
    },
  },
};
</script>
